export enum enCourseTheme {
  'black' = 0,
  'white' = 1,
}

export interface ICourseCustomizations {
  theme: enCourseTheme;
  title_color: string;
  description_color: string;
  image_cover?: string;
}

export interface IDomainCustomizations {
  subdomain?: string;
  login_background_image: string;
  logo_login: string;
}

export interface IHeaderCustomizations {
  header_background_color: string;
  header_link_color: string;
  header_logo: string;
  support_external_url: string;
}

type TCustomizations = ICourseCustomizations & IDomainCustomizations & IHeaderCustomizations;

export default TCustomizations;
